import { Component, Input, ChangeDetectionStrategy } from '@angular/core'
import { MatIcon } from '@angular/material/icon'

import {
  IRoleplayAssessmentDisplay,
  RoleplayAssessmentData,
} from '../../../../services/roleplay'
import {
  ASSESSMENT_ICON_MAP,
  ASSESSMENT_BG_COLOR_MAP,
  ASSESSMENT_ICON_COLOR_MAP,
} from '../../../../services/roleplay/addon/roleplay-assessment-visual.constants'

@Component({
  selector: 'app-roleplay-simple-assessment',
  standalone: true,
  imports: [MatIcon],
  templateUrl: './roleplay-simple-assessment.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './roleplay-simple-assessment.component.scss',
})
export class RoleplaySimpleAssessmentComponent implements IRoleplayAssessmentDisplay {
  @Input() assessment: RoleplayAssessmentData | undefined

  get iconName(): string | undefined {
    return this.assessment?.assessment != null
      ? ASSESSMENT_ICON_MAP[this.assessment.assessment]
      : undefined
  }

  get bgColor(): string | undefined {
    return this.assessment?.assessment != null
      ? ASSESSMENT_BG_COLOR_MAP[this.assessment.assessment]
      : undefined
  }

  get iconColor(): string | undefined {
    return this.assessment?.assessment != null
      ? ASSESSMENT_ICON_COLOR_MAP[this.assessment.assessment]
      : undefined
  }
}
